var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenStats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 69,
    viewBox: "0 0 341 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 69V69.5H0H341H341.5V69V0V-1.58679L340.59 -0.286641C335.387 7.1499 324.628 15.1386 309.267 21.1253C293.919 27.107 274.017 31.0736 250.578 30.5001C221.266 29.783 193.165 22.9458 168.945 16.2757C164.914 15.1656 160.988 14.0595 157.182 12.9871C149.563 10.8404 142.422 8.82838 135.872 7.18868C126.052 4.73042 117.503 3.09361 110.595 3.09361C102.594 3.09361 95.0803 5.09037 87.4923 7.50776C85.7504 8.06269 84.0057 8.63933 82.25 9.2196C76.3394 11.1731 70.3047 13.1676 63.8357 14.5128C47.1188 17.9889 27.5236 17.1176 0.270578 -0.420461L-0.5 -0.916349V0V69Z",
    fill: "url(#paint0_linear_2547_2365)",
    stroke: "#25CC7C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_2365",
    x1: 170.5,
    y1: 11,
    x2: 170.038,
    y2: 79.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25CC7C",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStats);
export default __webpack_public_path__ + "static/media/greenStats.a6b440c1c86a6fc481df4803cfdf56ef.svg";
export { ForwardRef as ReactComponent };